/*
 * @Author: your name
 * @Date: 2022-03-02 09:36:20
 * @LastEditTime: 2022-04-28 11:44:55
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \fore1f:\front_admin\src\components\libs\constant\constant.js
 */
export const gateway = window.baseGate.ApiUrl;
export const picway = window.baseGate.ApiUrl +'/file/fileProcessing/download?fileSource=ALIYUN&id=';//查看
export const uploadImgBase = window.baseGate.ApiUrl + '/file/fileProcessing/upload?fileSource=ALIYUN&'; //上传
export const uploadImgBaseApi = '/api/file/fileProcessing/upload?fileSource=ALIYUN&'; //上传
export const previewImgBase = window.baseGate.ApiUrl + '/file/fileProcessing/download?fileSource=ALIYUN&';//查看
export const upload4read = '/service-file-app/app/file/common/upload4read';//最新的上传
export const upload4down = '/service-file-app/app/file/common/upload4down';//最新的下载
// 百度识别
export const baiduUpload = window.baseGate.ApiUrl + '/file/vat/upload/vatInvoice?fileSource=ALIYUN&';
// 上传阿里
export const baiduUpload111 = window.baseGate.ApiUrl + '/file/vat/upload/vatInvoice?fileSource=ALIYUN&';

export const downBase = window.baseGate.ApiUrl + '/file/fileProcessing/downloadFile?fileSource=ALIYUN&';
export const interPictures = 'https://www.joolgo.com/wxicon/';
/**
 * @description 接口异常白名单 code值
 * @param {String} name   0 300-399 400-499 600-699
 * @returns  Boolean
 */
export const whiteCode = (code=0) => {
  return (code == 0 || (code >= 300 && code <= 399) || (code >= 400 && code <= 499) || (code >= 600 && code <= 699))
};

/**
 * @description:  富文本的导出方法， 总体配置
 * @param {editor}  富文本对象， 导出富文本对象方法
 * @param {config} 配置 自己随意加， 定义参数名称为方法的配置值
 * @return {type}
 */
//参数 富文本对象editor config
export function imageUpdateConfig(editor, config = {
  uploadImgMaxSize: 1000 * 1024 * 1024,
  uploadFileName: 'file'
}) {
  // 自定义 fileName
  editor.config.uploadFileName = config.uploadFileName
  editor.config.uploadImgMaxSize = config.uploadImgMaxSize
  editor.config.uploadImgShowBase64 = true;
  editor.config.uploadImgServer = 'api'+ upload4read

  editor.config.uploadImgHooks = {
    before: function (xhr, editor, files) {
        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
    },
    success: function (xhr, editor, result) {
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
    },
    fail: function (xhr, editor, result) {
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
    },
    error: function (xhr, editor) {
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
    },
    timeout: function (xhr, editor) {
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
    },

    // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
    // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
    customInsert: function (insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        var url = result.data.url
        // var url = window.baseGate.ApiUrl +'/file/fileProcessing/download?fileSource=ALIYUN&id=' +  result.id

        console.log(result, url)
        insertImg(url)

        // result 必须是一个 JSON 格式字符串！！！否则报错
    }
  }
}
